module.exports = __webpack_public_path__ + "static/media/01.cf8eebd1.webm";